import {TFilter, TList, TResponse, TUUID} from '@/types';
import faker from '@faker-js/faker';
import {getPositions, getSettlements} from './mock';
import {
  TFineryMarketDuty,
  TFineryMarketSettlement,
  TSettlementsCreateParams,
  TSettlementsSendParams,
} from './types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../api/ws';
import {
  ENDPOINT_ADMIN_FINERY,
  ENDPOINT_ADMIN_SETTLEMENTS,
  ENDPOINT_ADMIN_SETTLEMENTS_CREATE,
  ENDPOINT_ADMIN_SETTLEMENTS_SEND,
  ENDPOINT_ADMIN_SETTLEMENTS_REMOVE
} from '../../../constants/api';

export function apiAdminFineryPositions(): Promise<TList<TFineryMarketDuty>> {
  const url = ENDPOINT_ADMIN_FINERY;
  if (process.env.MOCK) {
    const limit = faker.mersenne.rand(10);
    const response = {
      list: getPositions(limit),
      count: limit * 10,
    };
    console.info({url, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url);
}

export function apiAdminFinerySettlements(
    params: TFilter<TFineryMarketSettlement>,
): Promise<TList<TFineryMarketSettlement>> {
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  const url = ENDPOINT_ADMIN_SETTLEMENTS;
  if (process.env.MOCK) {
    const response = {
      list: getSettlements(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

export function apiAdminFinerySettlementCreate(params: TSettlementsCreateParams): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_SETTLEMENTS_CREATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

export function apiAdminFinerySettlementSend(params: TSettlementsSendParams): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_SETTLEMENTS_SEND;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

export function apiAdminFinerySettlementRemove(params: {order_id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_SETTLEMENTS_REMOVE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}
